import { connect } from "react-redux";
import PurchaseHistoryView from "./purchase-history";
import { getUnit } from "~/admin/selectors";
import * as unitService from "~/core/units/unit-names";

const mapStateToProps = (state) => ({
    [unitService.UNIT_AREA]: getUnit(unitService.getUnitCode(unitService.UNIT_AREA), state),
    [unitService.UNIT_TIME]: getUnit(unitService.getUnitCode(unitService.UNIT_TIME), state),
    [unitService.UNIT_VOLUME]: getUnit(unitService.getUnitCode(unitService.UNIT_VOLUME), state),
});

export const PurchaseHistory = connect(mapStateToProps, null)(PurchaseHistoryView);
